<template>
    <div class="container">
        <ul>
            <li v-for="news of newsFeed" v-bind:key="news.id">
                <a :href="newsUrl(news)" target="_blank" class="news-title">{{ newsTitle(news) }}</a>
                <div class="news-summary">{{ newsSummary(news) }}</div>
            </li>
        </ul>
    </div>    
</template>

<script>
import NewsFeedService from "@/service/NewsFeedService.js";
import LangUtils from "@/utils/LangUtils.js";

const newsFeedService = new NewsFeedService();

export default {
    data() {
        return {
            newsFeed: null
        }
    },
    
    methods: {
        newsTitle(news) {
            return LangUtils.valueForLanguage(news.getTitle(), this.$i18n.locale);
        },
        newsSummary(news) {
            return LangUtils.valueForLanguage(news.getSummary(), this.$i18n.locale);
        },
        newsUrl(news) {
            return LangUtils.valueForLanguage(news.getUrl(), this.$i18n.locale);
        }
    },

    mounted() {
        newsFeedService.loadLatestNews().then((news) => {
            this.newsFeed = news;
        }).catch((error) => {
            console.log("error loading news: " + error);
        });
    }
}
</script>

<style scoped>
.container {
    text-align: left;
    padding: 0px;
}

ul {
    list-style: none;
    padding: 0px;
}

li {
    margin-top: 8px;
}

.news-title {
    display: block;
    font-weight: bold;
}

.news-summary {
    color: #555555;
    font-size: 14px;
}

</style>